import { render, staticRenderFns } from "./photoGalleryModel.vue?vue&type=template&id=52a8074c&scoped=true"
import script from "./photoGalleryModel.vue?vue&type=script&lang=js"
export * from "./photoGalleryModel.vue?vue&type=script&lang=js"
import style0 from "./photoGalleryModel.vue?vue&type=style&index=0&id=52a8074c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8074c",
  null
  
)

export default component.exports